
export function getError(error) {
	if (error.response)
		if (!error.response.data) {
			return 'Unexpected error';
		} else {
			if (error.response.status == 429 && error.response.headers['retry-after'])
				return 'Try again later';
			else if (error.response.status == 403)
				return 'Forbidden';
			else if (!error.response.data.error)
				return 'Unexpected error';
			else return error.response.data.error;
		}
	else {
		return 'Network error';
	}
}

export function createDropDown(items) {
	const div = document.createElement('div')
	div.classList.add('dropdown');
	div.classList.add('dropright');
	const btn = document.createElement('button');
	['btn', 'btn-secondary', 'dropdown-toggle'].forEach(cssClass => btn.classList.add(cssClass))
	btn.type = 'button';
	btn.innerText = 'Dropdown'
	btn.dataset.toggle = 'dropdown';
	btn.dataset.ariaExpanded = 'dropdown';
	const divInner = document.createElement('div');
	divInner.classList.add('dropdown-menu');
	items.forEach(item => {
		const a = document.createElement('a')
		a.classList.add('dropdown-item');
		a.innerText = item;

		divInner.appendChild(a);
	})
	div.appendChild(btn);
	div.appendChild(divInner);

	return div;
}

export function createDatatableButton(name, type, disabled, handler ) {
	const button = document.createElement('button');
	button.disabled = disabled;
	button.type = 'button';
	button.className = `btn btn-${type} mr-1 btn-ag-grid`;
	button.innerText = name;
	button.addEventListener('click', event => {
		event.preventDefault();
		handler(event);
	});

	return button;
}


export function createDatatableButtons(items) {
	const buttons = [];

	for (let item of items)
		buttons.push(createDatatableButton(item.name, item.type, !!item.disabled, item.handler));

	const div = document.createElement('div');
	for (let button of buttons)
		div.append(button);

	return div;
}

export function createDatatableCheckboxs(items) {
	const checkboxs = [];

	for (let item of items)
		checkboxs.push(createDatatableCheckbox(item.handler, item.orderId));

	const div = document.createElement('div');

	for (let checkbox of checkboxs)
		div.append(checkbox);

	return div;
}
export function createDatatableCheckbox(handler, orderId) {
	const checkbox = document.createElement('input');
	checkbox.type = 'checkbox';
	checkbox.id = orderId;
	checkbox.addEventListener('click', function () {
		handler(event);
		return checkbox.clicked;
	});

	return checkbox;
}

export function getContactInfoTypeIcon(id) {
	switch (id) {
		case 1:
			return 'fas fa-phone';
		case 2:
			return 'fas fa-envelope';
		case 3:
			return 'fas fa-link';
		default:
			return 'fas fa-exchange-alt';
	}
}

// Modified version of https://stackoverflow.com/a/13899011/2164304
export function from24To12(time) {
	// Check correct time format and split into components
	time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

	if (time.length > 1) { // If time format correct
		time = time.slice(1); // Remove full string match value
		time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
		time[0] = +time[0] % 12 || 12; // Adjust hours
	}
	return time.join(''); // return adjusted time or original string
}

// Modified version of https://stackoverflow.com/a/30033564/2164304
export function getLocationsCenter(locations) {
	const rad2degr = rad => rad * 180 / Math.PI;
	const degr2rad = degr => degr * Math.PI / 180;

	let sumX = 0;
	let sumY = 0;
	let sumZ = 0;

	for (let i = 0; i < locations.length; i++) {
		const lat = degr2rad(locations[i].latitude);
		const lng = degr2rad(locations[i].longitude);

		sumX += Math.cos(lat) * Math.cos(lng);
		sumY += Math.cos(lat) * Math.sin(lng);
		sumZ += Math.sin(lat);
	}

	const avgX = sumX / locations.length;
	const avgY = sumY / locations.length;
	const avgZ = sumZ / locations.length;

	const lng = Math.atan2(avgY, avgX);
	const hyp = Math.sqrt(avgX * avgX + avgY * avgY);
	const lat = Math.atan2(avgZ, hyp);

	return {
		latitude: rad2degr(lat),
		longitude: rad2degr(lng),
	};
}

export const authHeader = 'Authorization';